module.exports = __webpack_public_path__ + "static/bg-de15966a76e6dc00a62cf2edf707ec81.jpg";